<table mat-table [dataSource]="dataSource()" class="w-100">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> Name </th>
    <td mat-cell *matCellDef="let element">
      <div>
        <xui-file-icon [extension]="element.extension" [grayscale]="element.processing"></xui-file-icon>
        <span>{{ element.fileName }}</span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="uploaded">
    <th mat-header-cell *matHeaderCellDef class="d-responsive d-md"> Document Date </th>
    <td mat-cell *matCellDef="let element" class="d-responsive d-md"> {{ element.documentDate | date:'yyyy-MM-dd':'+0200' }} </td>
  </ng-container>

  <ng-container matColumnDef="size">
    <th mat-header-cell *matHeaderCellDef class="d-responsive d-md"> Size </th>
    <td mat-cell *matCellDef="let element" class="d-responsive d-md"> {{ element.size | fileSize }} </td>
  </ng-container>

  <ng-container matColumnDef="tags">
    <th mat-header-cell *matHeaderCellDef class="d-responsive d-lg"> Tags </th>
    <td mat-cell *matCellDef="let element" class="d-responsive d-lg">
      <mat-chip-listbox aria-label="tags">
        @for (tag of element.tags; track tag.tag) {
          <mat-chip-option class="mat-tag">{{ tag.tag }}</mat-chip-option>
        }
      </mat-chip-listbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> Actions </th>
    <td mat-cell *matCellDef="let element">
      @if (!element.processing) {
        <button mat-icon-button (click)="fileEditor.editAttachment()"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button (click)="fileEditor.deleteAttachment()"><mat-icon>delete</mat-icon></button>
        <button mat-icon-button (click)="fileDownloader.openUpload()"><mat-icon>open_in_new</mat-icon></button>
      }
      <xmed-file-downloader #fileDownloader [upload]="element" (downloadRequested)="downloadRequested.emit($event)"></xmed-file-downloader>
      <xmed-file-editor #fileEditor [upload]="element" (deleteRequested)="deleteRequested.emit($event)"></xmed-file-editor>
      @if (element.processing) {
        <mat-spinner diameter="28"></mat-spinner>
      }
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns();" [class.processing]="row.processing"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns().length">
      There are no files that have been uploaded. Upload a file to see it here.
    </td>
  </tr>
</table>
